import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";

function RmLeaderboard() {
	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
	const items = [];
	// const prevScrollY = useRef(0);
	let history = useHistory();
	useEffect(() => {
		localStorage.setItem("loader", "free");
		getLeaderboardData();
	}, []);
	const [leaderData, setLeaderData] = useState({"status":"failuer","self":{"dist_user_id": "","rank": "NA","points": 0,"name": "","city": "","profile_pic": ""},"leaders":[]});
	const [error1, setError] = useState(false);
	const [seasonAward, setSeasonAward] = useState('');
	const [leaders, setLeaders] = useState([]);
	const [startRank, setStartRank] = useState(1);
	const [endRank, setEndRank] = useState(20);

	const prevScrollY = useRef(0);
  	const [goingUp, setGoingUp] = useState(false);
	const onScroll = (e) => {
		const currentScrollY = e.target.scrollTop;
        // console.log(currentScrollY);
        // console.log("--------------");
		if (prevScrollY.current < currentScrollY && goingUp) {
			setGoingUp(false);
		}
		if (prevScrollY.current > currentScrollY && !goingUp) {
			setGoingUp(true);
		}
        // console.log(Math.ceil(window.innerHeight +currentScrollY - 75));
        // console.log( e.target.scrollHeight);
        // console.log(window.innerHeight);
		prevScrollY.current = currentScrollY;
		if (Math.ceil(window.innerHeight +currentScrollY - 75) === e.target.scrollHeight) {
			// Do load more content here!
			console.log("bottom");
			loadMore();
		}
		if(currentScrollY === 0){
			console.log("top");
			// loadMore("up")
		}
	};

	async function loadMore(){
		if(localStorage.getItem("loader") === "free"){
			localStorage.setItem("loader", "loading");
			let s = endRank + 1;
			let e = endRank + 100;
            let type=localStorage.getItem("lType");
            let body = {dist_user_id:user_id,start_rank:s,end_rank:e,type:type};
            if(localStorage.getItem("lFetch") !== localStorage.getItem("lType")){
                body = {dist_user_id:user_id,type:type};
            }
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
                body: JSON.stringify(body),	
            };
			const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
			const data = await response.json();
			if (data.status !== "success"){
				setError(true);
			}
			for (const [index, value] of data.leaders.entries()) {
				let pp = '';
				if(value.profile_pic === 'NA' || value.profile_pic === ''){
					pp = require("./../images/defaultProfile.png").default;
				} else {
					pp = value.profile_pic;
				}
				items.push(<li key={value.dist_user_id}>
				  	<a className="item">
					  <span className="leader-number">{value.rank}</span>
					  <img src={pp} alt="image" className="image" />
					  <div className="in">
						  <div className="leader">
							  {value.name}
							  <footer className="leader-state">{value.city}</footer>
						  </div>
						  <span className="leader-points">{value.points}<span className="border-bottom-red"> pts</span></span>
					  </div>
				  	</a>
			  	</li>);
		 	}
            if(localStorage.getItem("lFetch") === localStorage.getItem("lType")){
                setLeaders(leaders.concat(items));
            } else {
                setLeaders(items);
            }
            setEndRank(data.end_rank);
            localStorage.setItem("lFetch", type);
		    localStorage.setItem("loader", "free");
		}
	}
	const getLeaderboardData = async () => {
		
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({dist_user_id:user_id,type:"all"}),
			
		};
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
		const data = await response.json();
		if (data.status !== "success"){
			setError(true);
		}
        localStorage.setItem("lFetch", "all");
        localStorage.setItem("lType", "all");
		for (const [index, value] of data.leaders.entries()) {
			let pp = '';
			if(value.profile_pic === 'NA' || value.profile_pic === ''){
				pp = require("./../images/defaultProfile.png").default;
			} else {
				pp = value.profile_pic;
			}
		  	items.push(<li key={value.dist_user_id}>
				<a className="item">
					<span className="leader-number">{value.rank}</span>
					<img src={pp} alt="image" className="image" />
					<div className="in">
						<div className="leader">
							{value.name}
							<footer className="leader-state">{value.city}</footer>
						</div>
						<span className="leader-points">{value.points}<span className="border-bottom-red"> pts</span></span>
					</div>
				</a>
			</li>);
		}
		setLeaders(items);
		setSeasonAward(data.season_data.banner);
		setLeaderData(data);
		setStartRank(data.start_rank);
		setEndRank(data.end_rank);
	};

    async function myTeam(){
        if(localStorage.getItem("lType") === "myTeam"){
            localStorage.setItem("lType", "all");
        } else {
            localStorage.setItem("lType", "myTeam");
        }
        loadMore();
    }
	return (
<>
	{/* <HelmetProvider> */}
		<Helmet link={
			[{"rel": "stylesheet", "href": 'css/rm-leaderboard.css'}]
		}/>
	{/* </HelmetProvider> */}
	<div className="row no-gutters">
		{ error1 === false && (
      	<div className="application">
        	<div className="appHeader bg-transparent text-light position-relative yellow-header">
          		<div className="left">
					<a onClick={() => history.goBack()} className="headerButton goBack">
						<img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
					</a>
          		</div>
          	<div className="pageTitle">Leaderboard</div>
            <div className="right">
                <div className="headerButton" onClick={() => myTeam()}>
                    My Team
                </div>
            </div>
        </div>

        <div className="section bg-grey leaderboard-section px-14" id="bg-grey" onScroll={onScroll}>
            <ul className="listview image-listview leaderlist">
				{leaders}
            </ul>
        </div>

    </div>
		)}
		{ error1 === true && (
			<Redirect to='/'  />
		)}
		<div className="bg"></div>
	</div>
</>
	);
}

export default RmLeaderboard;
